import {CALL_API} from 'middleware/api';
import {TRANSFORM} from 'middleware/transform';
import * as ActionTypes from '../Popular';

export function fetchPopularMatches(data) {
    const {languageId} = data;
    return (dispatch) => {
        return dispatch({
                type: ActionTypes.GET_POPULAR_MATCHES,
                [CALL_API]: {
                    endpoint: `/api/event/popular?languageId=${languageId}`,
                    method: 'get',
                    types: [
                        ActionTypes.SUCCESS_GET_POPULAR_MATCHES,
                        ActionTypes.FAILURE_GET_POPULAR_MATCHES
                    ],
                    data
                },
                [TRANSFORM]: {
                    section: 'popularMatches',
                    transformType: 'init',
                    provider: (data) => data
                }
            }
        );
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/Popular.js